import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-view-detail-addendum',
  templateUrl: './view-detail-addendum.component.html',
  styleUrls: ['./view-detail-addendum.component.css'],
})
export class ViewDetailAddendumComponent implements OnChanges {
  @Input() isDialogOpen: boolean;
  @Input() addendum: any;
  @ViewChild('viewDetailDialog') viewDetailDialog!: TemplateRef<any>;
  constructor(private dialog: MatDialog, private sanitizer: DomSanitizer) {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDialogOpen'] && !changes['isDialogOpen'].firstChange) {
      this.openAddUserDialog();
    }
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  openAddUserDialog() {
    this.dialog.open(this.viewDetailDialog, {
      disableClose: true,
      autoFocus: false,
    });
  }
  // Close the dialog
  closeDialog() {
    this.dialog.closeAll();
  }
}
